import { render, staticRenderFns } from "./PreMintingActions.vue?vue&type=template&id=2829177e&"
import script from "./PreMintingActions.vue?vue&type=script&lang=js&"
export * from "./PreMintingActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports